import React, { useContext } from 'react';
import {
  useEffect,
  useState,
} from 'react';
import {
  Outlet,
  useNavigate,
  // useSearchParams,
} from 'react-router-dom';

import { useAuth } from 'react-oidc-context';
import { CircularProgress } from '@mui/material';
import { SnackbarContext } from '../../App';

export default function SetUpRequired(props) {
  const auth = useAuth();

  const navigate = useNavigate();

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    currentStep,
    setCurrentStep,
  ] = useState();

  const { setSessionExpired } = useContext(SnackbarContext);

  // useEffect(() => {
  //     if(!auth.user?.profile.accountant.ssid || !auth.user?.profile.accountant.verified ){
  //         navigate('/setup')
  //     }
  // })

  return (
    <React.Fragment>
      <>{props.children}</>
    </React.Fragment>
  );
}
